export default __webpack_public_path__ + "static/media/586.3267ae35.png";